module.exports = __webpack_public_path__ + "static/media/1017703.41dc8aef.png";